/**
 * Provides JS functionality for video bg on hero.
 */
class Hero extends DrupalBehavior {
  onReady(context) {
    // Check if video data exists.
    if(typeof drupalSettings.hero_video_bg !== "undefined") {
      const videoData = drupalSettings.hero_video_bg;
      // If is vimeo provider.
      if (videoData.provider === 'vimeo' && videoData.id) {
        const options = {
          id: videoData.id,
          width: 640,
          loop: true
        };

        // Initialize vimeo player.
        setTimeout(() => {
          const vimeoPlayer = new Vimeo.Player('hero-bg-video', options);
          Promise.all([vimeoPlayer.getVideoWidth(), vimeoPlayer.getVideoHeight()]).then(dimensions => {
            const [width, height] = dimensions;

            const sizeVideo = () => {
              let windowSize = window.outerWidth;
              let newWidth = windowSize + (windowSize * .57);
              let newHeight = newWidth * .36;
              let iframe = vimeoPlayer.element;

              if (navigator.userAgent.match(/iPhone|iPad|iPod/i) && window.matchMedia('(min-width: 991px) and (max-width: 1024px)')) {
                iframe.style.width = '1024px';
                iframe.style.height = '768px';
              }
              else {
                iframe.style.width = `${newWidth}px`;
                iframe.style.height = `${newHeight}px`;
                iframe.style.opacity = '1';
              }
            }

            sizeVideo();
            window.onresize = sizeVideo;
          });
          vimeoPlayer.setVolume(0);
          vimeoPlayer.play();
        }, 300);

        // If is youtube provider.
      } else if (videoData.provider === 'youtube' && videoData.id) {
        var tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        let youtubePlayer = null;

        const setYoutubeVideoRatio = () => {
          var url = 'https://www.youtube.com/watch?v=' + videoData.id;

          $.getJSON('https://noembed.com/embed', {
            format: 'json',
            url: url
          })
        };

        const onPlayerReady = (event) => {
          setYoutubeVideoRatio();
          event.target.mute()
          event.target.playVideo();
        };

        window.onYouTubeIframeAPIReady = () => {
          // Initialize youtube player.
          youtubePlayer = new YT.Player('hero-bg-video', {
            height: '360',
            width: '640',
            videoId: videoData.id,
            events: {
              'onReady': onPlayerReady,
            }
          });
        };
      }
    }
  }

}

DrupalBehavior.register('camc.components', 'hero', Hero);
